'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { useCountUp } from "react-countup";
import { cn } from "../../common/helpers.js";
import { Typography } from "../Typography/index.js";
import { Icon } from "../Icon/index.js";
import { Card } from "../Card/index.js";
import { Skeleton } from "../Skeleton/index.js";
/**
 * Card Stat - [API](https://scl.sharp.com/?path=/docs/components-cardstat) | [DSM](https://sharphealthcare.notion.site/Card-stat-item-89e27119bca24d9f988d74d9e8dd7d10)
 *
 * @example
 *
 * <CardStat
 *  icon="syringe"
 *  statistic={[0, 1000]}
 *  description="Vaccines given"
 * />
 */ const CardStat = /*#__PURE__*/ forwardRef((props, ref)=>{
    var _start_toString_split_, _start_toString_split, _end_toString_split_, _end_toString_split, _slotProps_description;
    const { as, icon, statistic = 0, description, prefix, suffix, slots = {}, slotProps = {}, className } = props, rest = _object_without_properties(props, [
        "as",
        "icon",
        "statistic",
        "description",
        "prefix",
        "suffix",
        "slots",
        "slotProps",
        "className"
    ]);
    const countUpRef = useRef(null);
    const range = Array.isArray(statistic) ? statistic : [
        statistic,
        statistic
    ];
    const [start, end] = range;
    var _start_toString_split__length;
    const startDecimals = (_start_toString_split__length = (_start_toString_split = start.toString().split('.')) === null || _start_toString_split === void 0 ? void 0 : (_start_toString_split_ = _start_toString_split[1]) === null || _start_toString_split_ === void 0 ? void 0 : _start_toString_split_.length) !== null && _start_toString_split__length !== void 0 ? _start_toString_split__length : 0;
    var _end_toString_split__length;
    const endDecimals = (_end_toString_split__length = (_end_toString_split = end.toString().split('.')) === null || _end_toString_split === void 0 ? void 0 : (_end_toString_split_ = _end_toString_split[1]) === null || _end_toString_split_ === void 0 ? void 0 : _end_toString_split_.length) !== null && _end_toString_split__length !== void 0 ? _end_toString_split__length : 0;
    const decimals = Math.max(startDecimals, endDecimals);
    useCountUp({
        ref: countUpRef,
        start,
        end,
        prefix,
        suffix,
        separator: ',',
        enableScrollSpy: true,
        scrollSpyOnce: true,
        decimals
    });
    const Root = as !== null && as !== void 0 ? as : Card;
    const rootProps = (slots === null || slots === void 0 ? void 0 : slots.icon) ? rest : _object_spread({
        variant: 'filled'
    }, rest);
    var _slots_icon;
    const IconComponent = (_slots_icon = slots.icon) !== null && _slots_icon !== void 0 ? _slots_icon : Icon;
    var _slotProps_icon;
    const _ref = (_slotProps_icon = slotProps === null || slotProps === void 0 ? void 0 : slotProps.icon) !== null && _slotProps_icon !== void 0 ? _slotProps_icon : {}, { className: iconSlotPropsClassName } = _ref, iconSlotProps = _object_without_properties(_ref, [
        "className"
    ]);
    const iconProps = (slots === null || slots === void 0 ? void 0 : slots.icon) ? iconSlotProps : _object_spread({
        icon
    }, iconSlotProps);
    var _slots_statistic;
    const Stat = (_slots_statistic = slots === null || slots === void 0 ? void 0 : slots.statistic) !== null && _slots_statistic !== void 0 ? _slots_statistic : 'div';
    var _slotProps_statistic;
    const _ref1 = (_slotProps_statistic = slotProps === null || slotProps === void 0 ? void 0 : slotProps.statistic) !== null && _slotProps_statistic !== void 0 ? _slotProps_statistic : {}, { className: statSlotPropsClassName } = _ref1, statSlotProps = _object_without_properties(_ref1, [
        "className"
    ]);
    var _slots_description;
    const Description = (_slots_description = slots === null || slots === void 0 ? void 0 : slots.description) !== null && _slots_description !== void 0 ? _slots_description : Typography;
    var _slotProps_description1;
    const _ref2 = (_slotProps_description1 = slotProps === null || slotProps === void 0 ? void 0 : slotProps.description) !== null && _slotProps_description1 !== void 0 ? _slotProps_description1 : {}, { className: descriptionSlotPropsClassName } = _ref2, descriptionSlotProps = _object_without_properties(_ref2, [
        "className"
    ]);
    const descriptionTypographyProps = {
        variant: 'body-semibold',
        align: 'center'
    };
    // If description slot provided then do not spread Typography specific props else combine
    const descriptionProps = (slots === null || slots === void 0 ? void 0 : slots.description) ? descriptionSlotProps : _object_spread({}, descriptionTypographyProps, descriptionSlotProps);
    return /*#__PURE__*/ _jsxs(Root, _object_spread_props(_object_spread({
        variant: "filled",
        className: cn('flex flex-col items-center p-8 w-full', className)
    }, rootProps), {
        ref: ref,
        children: [
            (icon !== null && icon !== void 0 ? icon : slots === null || slots === void 0 ? void 0 : slots.icon) && /*#__PURE__*/ _jsx(IconComponent, _object_spread({
                className: cn('text-primary h-8 mb-2', iconSlotPropsClassName)
            }, iconProps)),
            /*#__PURE__*/ _jsx(Stat, _object_spread_props(_object_spread({
                className: cn('text-primary text-center text-5xl font-bold line-clamp-1 w-full', statSlotPropsClassName)
            }, statSlotProps), {
                ref: countUpRef,
                children: /*#__PURE__*/ _jsx(Skeleton, {})
            })),
            (description !== null && description !== void 0 ? description : slotProps === null || slotProps === void 0 ? void 0 : (_slotProps_description = slotProps.description) === null || _slotProps_description === void 0 ? void 0 : _slotProps_description.children) && /*#__PURE__*/ _jsx(Description, _object_spread_props(_object_spread({
                className: cn('line-clamp-2', descriptionSlotPropsClassName)
            }, descriptionProps), {
                children: description
            }))
        ]
    }));
});
export { CardStat };
